<template>
  <div style="display: flex">
    <div style="width: 280px">
      <div class="tip">方式一</div>
      <img
        style="
          width: 138px;
          height: 138px;
          margin: 0 auto;
          display: block;
          margin-top: 82px;
        "
        :src="qrcode"
        alt=""
      />
      <p style="width: 182px; text-align: center" class="upgrade-text">
        添加爱设计企业微信客服咨询我们会有专人为您服务
      </p>
    </div>
    <div style="margin-left: 60px">
      <div class="tip">方式二</div>
      <div class="tip1">
        留下您的联系方式，我们的工作人员将在1个工作日内与您联系。
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item style="display: flex" label="姓 名" prop="name">
          <el-input
            style="width: 350px"
            placeholder="请输入姓名"
            v-model="form.name"
          ></el-input>
        </el-form-item>
        <el-form-item style="display: flex" label="手 机" prop="mobile">
          <el-input
            style="width: 350px"
            maxlength="11"
            placeholder="请输入手机号"
            v-model="form.mobile"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="企业名称"
          style="display: flex"
          prop="company_name"
        >
          <el-input
            style="width: 350px"
            placeholder="请输入企业名称"
            v-model="form.company_name"
          ></el-input>
        </el-form-item>
        <el-form-item style="display: flex" label="职 位" prop="job">
          <el-input
            style="width: 350px"
            placeholder="请输入职称"
            v-model="form.job"
          ></el-input>
        </el-form-item>
        <el-form-item style="display: flex" label="关注问题">
          <el-select
            multiple
            collapse-tags
            v-model="form.message"
            style="width: 350px"
            :placeholder="placeholder"
          >
            <el-option
              v-for="item in cities"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
              <el-checkbox-group
                v-model="checkList"
                @change="handleCheckChange"
              >
                <el-checkbox :label="item.label">{{ item.value }}</el-checkbox>
              </el-checkbox-group>
            </el-option>
          </el-select>
        </el-form-item>
        <el-button
          type="primary"
          style="width: 182px; margin: 0 auto; display: block"
          @click="onSubmit('form')"
          >提交</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { Landing } from "@/config/axios/landing.js";
import statistics from "@/utils/statistic/statistics";
import tokenFunc from "@/config/static/token";
export default {
  name: "question",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        const reg = /^1[1-9][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      placeholder: "请选择您关注的问题（多选）",
      checkList: [],
      form: {
        company_name: "",
        name: "",
        job: "",
        mobile: "",
        email: "",
        message: "",
        source: 2,
      },
      cities: [
        {
          value: "规避版权风险",
          label: "规避版权风险",
        },
        {
          value: "设计分发协作",
          label: "设计分发协作",
        },
        {
          value: "定制设计服务",
          label: "定制设计服务",
        },
      ],
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
          {
            validator: checkPhone,
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: ["qrcode"],
  computed: {
    loginInfo() {
      return this.$store.getters.loginInfo;
    },
  },
  methods: {
    handleCheckChange(val) {
      console.log(val.length);
      if (val.length > 0) {
        this.placeholder = "您关注的问题，已选择" + val.length + "项";
      } else {
        this.placeholder = "请选择您关注的问题（多选）";
      }
      // this.form.message = val.join(",");
    },
    onSubmit(form) {
      if (tokenFunc.getToken()) {
        this.form.user_id = this.loginInfo.id
      }
      this.form.message = this.checkList.join(",");
      this.$refs[form].validate((valid) => {
        if (valid) {
          Landing.getApply(this.form)
            .then((res) => {
              this.form = {};
              this.form.source = 2;
              this.form.email = "";
              this.checkList = [];
              this.placeholder = "请选择您关注的问题（多选）";
              this.$emit("upClose");
              this.$message(res.message);
              // 埋点上报
              statistics.__sendEvent({
                statsMark: "企业落地页-表单提交按钮点击pv",
                projectPage: this.$route.meta.projectPage,
                projectArea: "63",
                eventArea: "63",
                eventType: "3",
                eventId: "259",
                eventName: "company_vip_page_submit_pv",
              });
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  margin: 0 auto;
}
.tip {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #3b3946;
}
.tip1 {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #696571;
  margin: 14px 0;
}
::v-deep( .el-form-item) {
  margin-right: 24px;
  margin-bottom: 20px;
}

::v-deep( .el-form-item__label) {
  text-align: right;
  float: none;
  word-break: break-word;
  font-family: PingFangSC-Semibold, PingFang SC;
  color: #333333;
  font-weight: 600;
  width: 80px;
}

::v-deep( .el-tag.el-tag--info) {
  display: none;
}

.form-row {
  display: flex;
}
</style>
<style>
.el-popper[x-placement^="bottom"] {
  margin-top: 0;
  overflow: hidden;
  border: 1px solid #dedede;
}
.el-popper[x-placement^="top"] {
  margin-bottom: 0;
  top: 327px;
  overflow: hidden;
  border: 1px solid #dedede;
}
.el-popper[x-placement^="top"] .popper__arrow {
  display: none;
}
.el-popper[x-placement^="bottom"] .popper__arrow {
  display: none;
}
.el-select-dropdown__item:hover {
  background: #f2f2f7;
}
.el-select-dropdown__item {
  height: 42px;
  line-height: 42px;
}
.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background: #f2f2f7;
}
.el-select-dropdown__list {
  padding: 0;
}
</style>
